import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const UserSchema = z.object({
  userId: PrimaryKeySchema,
  fullName: z.string().min(1),
  nickname: z.string().min(1).optional(),
  hashedPassword: z.string().min(1), // bcrypt field
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type User = z.infer<typeof UserSchema>;

export const UsersSchema = z.array(UserSchema);

export type Users = z.infer<typeof UsersSchema>;

export const UserFiltersSchema = z
  .object({
    userIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    userEmails: commaDelimitedList(z.string().email().array()).optional(),
    teamIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    fullNameLike: z.string().optional(),
    nicknameLike: z.string().optional(),
  })
  .merge(
    createOffsetPaginationRequestQuerySchema(z.enum(['createdAt', 'fullName'])),
  );

export type UserFilters = z.infer<typeof UserFiltersSchema>;
